<app-main-header [breadcrumbs]="breadcrumbs"></app-main-header>

<ion-content>
  <div
    class="d-flex justify-content-center align-items-center h-75"
    *ngIf="!statusLoaded || !equipmentLoaded"
  >
    <div class="spinner-border text-warning" role="status">
      <span class="visually-hidden">
        {{ 'manual_activations' | translation }}:
        {{ 'auth_loading' | translation }}
      </span>
    </div>
  </div>

  <div *ngIf="statusLoaded && equipmentLoaded">
    <div class="container-fluid my-2">
      <div class="row">
        <div class="col-12">
          <div class="card my-3">
            <div
              class="card-body d-flex align-items-center justify-content-between"
            >
              <div>
                <h1 class="fs-2 m-0">
                  {{ 'manual_activations' | translation }}
                </h1>
                <span *ngIf="!isConnected" style="color: red">{{
                  'irrigation_terminal_disconnected' | translation
                }}</span>
              </div>

              <a (click)="reload()">
                <ion-icon
                  [name]="'reload-outline'"
                  [style.cursor]="'pointer'"
                  [style.color]="'var(--irrigation-border)'"
                ></ion-icon>
              </a>
            </div>
          </div>
        </div>

        <div class="col-12">
          <div class="card mb-3 action-card">
            <div class="card-body">
              <h6 class="fs-4 m-0 mb-4">
                {{
                  'manual_activations_water_system_start_filters_clean'
                    | translation
                }}
              </h6>
              <ng-continaer *ngFor="let waterSystemId of waterSystemsArray()">
                <ion-button
                  class="climate-button btn-height"
                  fill="outline"
                  [disabled]="!isConnected"
                  (click)="startFiltersCleaning(waterSystemId)"
                >
                  <ion-icon
                    [name]="'play'"
                    [style.color]="'var(--irrigation-border)'"
                  ></ion-icon>
                  <div>C{{ waterSystemId + 1 }}</div>
                </ion-button>
              </ng-continaer>
            </div>
          </div>
        </div>

        <div class="col-12">
          <div class="card mb-3 action-card">
            <div class="card-body irrigation-border">
              <h6 class="fs-4 m-0 mb-4">
                {{
                  'manual_activations_water_system_stop_filters_clean'
                    | translation
                }}
              </h6>
              <ng-continaer *ngFor="let waterSystemId of waterSystemsArray()">
                <ion-button
                  class="climate-button go-back-button btn-height"
                  fill="outline"
                  [disabled]="!isConnected"
                  (click)="stopFiltersCleaning(waterSystemId)"
                >
                  <ion-icon
                    [name]="'stop'"
                    [style.color]="'var(--irrigation-border)'"
                  ></ion-icon>
                  <div>C{{ waterSystemId + 1 }}</div>
                </ion-button>
              </ng-continaer>
            </div>
          </div>
        </div>

        <div class="col-12" *ngIf="warp >= 30305">
          <div class="card mb-3 action-card">
            <div class="card-body">
              <h6 class="fs-4 m-0 mb-4">
                {{ 'manual_activations_water_system_lock' | translation }}
              </h6>
              <ng-continaer *ngFor="let waterSystemId of waterSystemsArray()">
                <ion-button
                  class="climate-button go-back-button btn-height"
                  fill="outline"
                  [disabled]="!isConnected"
                  (click)="waterSystemLock(waterSystemId)"
                >
                  <ion-icon
                    [name]="'lock-closed'"
                    [style.color]="
                      isLocked(waterSystemId)
                        ? 'red'
                        : 'var(--irrigation-border)'
                    "
                  ></ion-icon>
                  <div>C{{ waterSystemId + 1 }}</div>
                </ion-button>
              </ng-continaer>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ion-content>
